/**
 * Regex to check dutch housenumbers
 * @type {RegExp}
 */

const houseNumber = /^(?:[a-zA-Z0-9 ]+(?:-(?!$))?)+$/

export default houseNumber
